import React from 'react';
import './Contact.css';

const Contact = () => {
  return (
    <div className="contact-page">
      {/* Hero Section */}
      <section className="contact-hero">
        <div className="hero-content">
          <h1 className="contact-title">Kontakt</h1>
          <p className="contact-subtitle">Ta gjerne kontakt – jeg svarer så fort jeg kan</p>
        </div>
      </section>

      {/* Main Content */}
      <section className="contact-content">
        <div className="container">
          <div className="contact-card">
            <h2>Rohde Lysveving</h2>
            <p className="lead">For henvendelser om timer, samarbeid eller spørsmål</p>

            <div className="contact-info">
              <div className="info-item">
                <span className="label">Telefon</span>
                <a href="tel:+4799266604" className="value">+47 992 66 604 </a>
              </div>
              <div className="info-item">
                <span className="label">E‑post</span>
                <a href="mailto:lysveving@gmail.com" className="value">lysveving@gmail.com</a>
              </div>
            </div>

            <div className="notes">
              <p>Send gjerne en e‑post med noen ord om hva du ønsker hjelp med, så finner vi et tidspunkt som passer.</p>
            </div>
          </div>
        </div>
      </section>
    </div>
  );
};

export default Contact;


